import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Global Selectors
import {
    makeSelectTimesheetValue
    // @ts-ignore
} from 'services/timesheet/selectors';

interface OwnProps {
    children?: React.ReactElement | React.ReactElement[];
    FallbackComponent?: React.ReactElement | React.ReactElement[];
}

interface ConnectedProps {
    personId?: number;
}

type Props = OwnProps & ConnectedProps;

/**
 * Conditionally hides children based on if the selected timesheet is for an individual person or not.
 */
export class SelectedTimesheetPersonExistsGate extends React.PureComponent<
    Props
> {
    render(): React.ReactElement | React.ReactElement[] | null {
        const { children, FallbackComponent, personId } = this.props;
        if (!personId) {
            return FallbackComponent || null;
        }
        return children || null;
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    personId: makeSelectTimesheetValue('personId')
});

export default connect(mapStateToProps)(SelectedTimesheetPersonExistsGate);
